import { render } from "./PartnerSlide.vue?vue&type=template&id=39bda662&ts=true"
import script from "./PartnerSlide.vue?vue&type=script&lang=ts"
export * from "./PartnerSlide.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__